import React from 'react'
import styled from 'styled-components'
import arrowDownSVG from 'static/img/arrow_down_dark.svg'
import { FieldWrapper, Label, InputWrapper, StyledError } from './styles'

export default function SelectField({
  input,
  meta,
  options = [],
  multiple = false,
  placeholder,
  label,
  required,
  ...props
}) {
  function wrapOnChange(e) {
    let { value } = e.target
    props.onChange(value)
    input.onChange(value)
  }
  return (
    <FieldWrapper>
      {label && <Label htmlFor={input.name}>{label}</Label>}
      <InputWrapper>
        <StyledSelect
          {...props}
          id={input.name}
          multiple={multiple}
          placeholder={placeholder}
          type="select"
          {...multiple && { size: 8 }}
          {...input}
          defaultValue="initial"
          required={required}
          onSelect={wrapOnChange}
          onChange={props.onChange ? wrapOnChange : input.onChange}>
          {placeholder && (
            <option
              key="placeholder"
              value=""
              checked
              {...required && { disabled: true, hidden: true }}>
              {placeholder}
            </option>
          )}
          {options.map(option => {
            let value
            let label
            if (typeof option === 'object') {
              value = option.value
              label = option.label
            } else {
              value = label = option
            }
            return (
              <option key={value} value={value}>
                {label}
              </option>
            )
          })}
        </StyledSelect>
        {meta.touched && meta.error && <StyledError>{meta.error}</StyledError>}
      </InputWrapper>
    </FieldWrapper>
  )
}

export const StyledSelect = styled.select`
  width: 100%;
  height: ${({ multiple }) => (!multiple ? '48px' : 'unset')};
  border: 2px solid ${({ theme }) => theme.colors.neutral};
  color: grey;
  appearance: none;
  cursor: pointer;
  background-image: ${({ multiple }) => (!multiple ? `url(${arrowDownSVG})` : 'unset')};
  background-position: calc(100% - 13px) center;
  background-repeat: no-repeat;
  padding-left: 9px;
  padding-right: 38px;
`
